<div>
  <nz-page-header nzBackIcon class="bg-slate-100" [nzGhost]="false">
    <nz-page-header-title *ngIf="isAdd" class="text-primary"
      >{{ 'users.addEdit.addTitle' | transloco }}
    </nz-page-header-title>
    <nz-page-header-title *ngIf="!isAdd" class="text-primary"
      >{{ 'users.addEdit.editTitle' | transloco }}
    </nz-page-header-title>
  </nz-page-header>
</div>
<div class="my-8">
  <div class="grid md:grid-cols-2 xl:grid-cols-3">
    <div>
      <form nz-form [formGroup]="userForm">
        <nz-form-item class="lg:flex">
          <nz-form-label class="w-1/4 md:w-1/3" nzRequired nzFor="firstname"
            >{{ 'users.addEdit.firstName' | transloco }}
          </nz-form-label>
          <nz-form-control [nzErrorTip]="firstNameCheck">
            <input
              type="text"
              nz-input
              class="w-full"
              formControlName="firstname"
              [placeholder]="'users.addEdit.placeholders.firstName' | transloco" />
          </nz-form-control>
          <ng-template #firstNameCheck>
            <span *ngIf="formErrors.firstname.required">
              {{ 'users.addEdit.errors.firstNameRequired' | transloco }}
            </span>
          </ng-template>
        </nz-form-item>
        <nz-form-item class="lg:flex">
          <nz-form-label class="w-1/4 md:w-1/3" nzRequired nzFor="lastname"
            >{{ 'users.addEdit.lastName' | transloco }}
          </nz-form-label>
          <nz-form-control [nzErrorTip]="lastNameCheck">
            <input
              type="text"
              nz-input
              class="w-full"
              formControlName="lastname"
              [placeholder]="'users.addEdit.placeholders.lastName' | transloco" />
          </nz-form-control>
          <ng-template #lastNameCheck>
            <span *ngIf="formErrors.lastname.required">
              {{ 'users.addEdit.errors.lastNameRequired' | transloco }}
            </span>
          </ng-template>
        </nz-form-item>
        <nz-form-item class="lg:flex">
          <nz-form-label class="w-1/4 md:w-1/3" nzRequired nzFor="email"
            >{{ 'users.addEdit.email' | transloco }}
          </nz-form-label>
          <nz-form-control [nzErrorTip]="emailCheck">
            <input
              nz-input
              class="w-full"
              formControlName="email"
              [placeholder]="'users.addEdit.placeholders.email' | transloco" />
          </nz-form-control>
          <ng-template #emailCheck>
            <span *ngIf="formErrors.email.required"> {{ 'users.addEdit.errors.emailRequired' | transloco }} </span>
            <span *ngIf="formErrors.email.email"> {{ 'users.addEdit.errors.emailInvalid' | transloco }} </span>
          </ng-template>
        </nz-form-item>
        <nz-form-item class="lg:flex">
          <nz-form-label class="w-1/4 md:w-1/3" nzRequired nzFor="mobile">
            {{ 'users.addEdit.contactNumber' | transloco }}
          </nz-form-label>
          <nz-form-control [nzErrorTip]="contactNumberCheck">
            <nz-input-group [nzAddOnBefore]="selectBefore">
              <ng-template #selectBefore>
                <nz-select
                  nzAllowClear
                  nzShowSearch
                  [nzPlaceHolder]="'users.addEdit.placeholders.dialCode' | transloco"
                  formControlName="dialCode" style="width: 100px"
                  [nzDropdownStyle]="{ width: '250px' }">
                  <nz-option *ngFor="let data of countries"
                             [nzValue]="data.dialing_code"
                             nzCustomContent="true"
                             [nzLabel]="data.dialing_code + ' ' + data.name">
                    <div class="flex">
                      <img [src]="data.image" width="20" height="20" alt=" couintry">
                      <span class="mx-2">{{data.name}}</span>
                      <span>{{data.dialing_code}}</span>
                    </div>
                  </nz-option>
                </nz-select>
              </ng-template>
              <input
                nz-input
                formControlName="mobile"
                [placeholder]="'users.addEdit.placeholders.contactNumber' | transloco"
              />
            </nz-input-group>
            <ng-template #contactNumberCheck>
            <span *ngIf="formErrors.mobile.required"
            >{{ 'users.addEdit.errors.contactNumberRequired' | transloco }}</span
            >
              <span *ngIf="formErrors.mobile.pattern"
              >{{ 'users.addEdit.errors.contactNumberInvalid' | transloco }}</span
              >
            </ng-template>
          </nz-form-control>
        </nz-form-item>
        <nz-form-item class="lg:flex">
          <nz-form-label class="w-1/4 md:w-1/3" nzRequired nzFor="role"
            >{{ 'users.addEdit.role' | transloco }}
          </nz-form-label>
          <nz-form-control [nzErrorTip]="roleCheck">
            <nz-spin [nzSpinning]="dataLoading">
              <nz-select formControlName="role" [nzPlaceHolder]="'users.addEdit.placeholders.role' | transloco">
                <nz-option
                  *ngFor="let role of allRoles"
                  [nzValue]="role._id"
                  nzLabel="{{ role.name }}"></nz-option>
              </nz-select>
            </nz-spin>
          </nz-form-control>
          <ng-template #roleCheck>
            <span *ngIf="formErrors.role.required"> {{ 'users.addEdit.errors.roleRequired' | transloco }} </span>
          </ng-template>
        </nz-form-item>
        <nz-form-item class="lg:flex">
          <nz-form-label class="w-1/4 md:w-1/3" nzRequired nzFor="active"
            >{{ 'users.addEdit.status' | transloco }}
          </nz-form-label>
          <nz-form-control [nzErrorTip]="statusCheck">
            <nz-select formControlName="active" [nzPlaceHolder]="'users.addEdit.placeholders.status' | transloco">
              <nz-option [nzValue]="true" [nzLabel]="'users.addEdit.statusOptions.active' | transloco"></nz-option>
              <nz-option [nzValue]="false" [nzLabel]="'users.addEdit.statusOptions.inactive' | transloco"></nz-option>
            </nz-select>
          </nz-form-control>
          <ng-template #statusCheck>
            <span *ngIf="formErrors.active.required"> {{ 'users.addEdit.errors.statusRequired' | transloco }} </span>
          </ng-template>
        </nz-form-item>
        <div class="flex justify-end">
          <button
            nz-button
            nzType="primary"
            *ngIf="isAdd"
            [disabled]="userForm.invalid"
            (click)="addUser()">
            {{ 'users.addEdit.buttons.add' | transloco }}
          </button>
          <button
            nz-button
            nzType="primary"
            *ngIf="!isAdd"
            [disabled]="userForm.invalid"
            (click)="editUser()">
            {{ 'users.addEdit.buttons.update' | transloco }}
          </button>
        </div>
        <div>
          <nz-alert
            *ngIf="actionMessage.display && actionMessage.isAdd"
            class="mt-2"
            [nzType]="actionMessage.type"
            [nzMessage]="actionMessage.message"
            nzShowIcon
            nzCloseable></nz-alert>
        </div>
      </form>
    </div>
  </div>
</div>
